const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (!values.educationStage) {
    errors.educationStage = 'Esse campo não pode ficar vazio';
  }
  if (!values.order) {
    errors.order = 'Esse campo não pode ficar vazio';
  }
  return errors;
};

export default validate;
